// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loader":"vQ9vm"};